<template>
  <div v-if="value">
    <div
      class="v-input v-input--is-label-active v-input--is-disabled v-input--is-dirty theme--light v-text-field v-text-field--is-booted"
    >
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-text-field__slot">
            <label
              for="span-en"
              class="v-label v-label--active theme--light"
              style="left: 0px; right: auto; position: absolute;"
            >{{label}}</label>
            <span id="span-en" style="color: rgba(0, 0, 0, 0.38);">{{trans(value,field)}}</span>
          </div>
        </div>
        <div class="v-text-field__details">
          <div class="v-messages theme--light">
            <div class="v-messages__wrapper"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { translate2 } from "../trans2";
export default {
  name: "trans-field",
  props: ["value", "label", "field"],
  mounted() {
    this.createTranslations();
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    currentLanguageIndex() {
      // console.log(this.languages, this.value);
      if (this.languages && this.languages.length > 1) {
        const langs = this.languages.filter(
          o => o.language === this.language.language
        );
        // console.log(langs);
        if (langs.length > 0) return this.languages.indexOf(langs[0]);
      }
      return -1;
    },
    currentTranslationsIndex() {
      // console.log(this.languages, this.value);
      // console.log(this.value.Translations.filter(o => o.LanguageCode === "fr"));
      if (this.value.Translations && this.value.Translations.length > 1) {
        const langs = this.value.Translations.filter(
          o => o.LanguageCode === this.language.language
        );
        // console.log(langs);
        if (langs.length > 0) return this.value.Translations.indexOf(langs[0]);
      }
      // console.log(this.value.Translations.filter(o => o.LanguageCode === "fr"));
      return -1;
    }
  },
  watch: {
    value: {
      handler() {
        this.createTranslations();
        // console.log(this.label);
      }
    },
    dialog: {
      handler(v) {
        if (!v) this.showTrans = false;
      }
    }
  },
  methods: {
    createTranslations() {
      // console.log(this.value);
      for (const lang of this.languages) {
        // console.log(lang);
        if (!this.value.Translations) this.value.Translations = [];
        if (
          lang.language !== "en" &&
          this.value.Translations.filter(o => o.LanguageCode === lang.language)
            .length === 0
        ) {
          // console.log(lang);
          this.value.Translations.push({
            LanguageCode: lang.language
          });
        }
      }
    },
    trans(item, field) {
      return translate2(item, field);
    }
  }
};
</script>